<!-- ============================================================== -->
<!-- Left Sidebar - style you can find in sidebar.scss  -->
<!-- ============================================================== -->
<aside class="left-sidebar ambiente">
  <!-- Sidebar scroll-->
  <div class="scroll-sidebar">
    <!-- Sidebar navigation-->
    <nav class="sidebar-nav ambiente">
      <ul id="sidebarnav">

        <li class="nav-devider"></li>
        <li class="nav-small-cap" style="color: white;">PERSONAL</li>
        <li>
          <a href="/" aria-expanded="false" style="color: white;">
            <em class="mdi mdi-home-outline"></em>
            <span class="hide-menu">Procesos Activos</span>
          </a>

          <a (click)="TryCrearNuevoProceso()" aria-expanded="false" class="nuevo-proceso-span" style="color: white;"
            *ngIf="procesado && !loadingNuevoProceso">
            <em class="mdi mdi-account-convert"></em>
            <span class="hide-menu">Nuevo Proceso</span>
          </a>
          <a (click)="showMessageLoadingNuevoProceso()" aria-expanded="false" class="nuevo-proceso-span"
            style="color: white;" *ngIf="procesado && loadingNuevoProceso">
            <em class="mdi mdi-account-convert"></em>
            <span class="hide-menu">Nuevo Proceso</span>
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </a>

        </li>


      </ul>
    </nav>
    <!-- End Sidebar navigation -->
  </div>
  <!-- End Sidebar scroll-->
</aside>
<!-- ============================================================== -->
<!-- End Left Sidebar - style you can find in sidebar.scss  -->
<!-- ============================================================== -->


<!-- Modal número de procesos permitidos -->
<div class="modal fade" id="maximoProcesosActivosModal" tabindex="-1" aria-labelledby="maximoProcesosActivosModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body">
        <p class="text-left">Estimado(a) estudiante,</p>
        <p class="text-left">
          Ya tienes un proceso seleccionado, no puedes crear nuevos procesos.
        </p>
      </div>
    </div>
  </div>
</div>
<!-- Modal número de procesos permitidos -->


<!-- Modal Lista De Espera -->
<div class="modal fade" id="modalListaDeEspera" tabindex="-1" aria-labelledby="modalListaDeEspera" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body">
        <p class="text-left">Estimado(a) Postulante:</p>
        <p class="text-left">
          De acuerdo a nuestros registros estás en una lista de espera para {{this.carrera}}
<!--          <span *ngIf="!tieneCarrerasListaEspera" class="font-weight-bold">{{postulacionesListaEspera}}</span>-->
<!--          <span *ngIf="tieneCarrerasListaEspera">-->
<!--            una de nuestras carreras adscritas al Proceso de Admisión Centralizada-->
<!--          </span>-->
          , por lo que no estás habilitado en estos momentos para acceder a matricularte, te recomendamos que desde el
          26 de febrero estés revisando en este mismo portal si quedaste seleccionado en tu lista de espera.
        </p>
        <p class="text-left">
          Atentamente, <br />
          Dirección de Admisión, Santo Tomás.
        </p>
      </div>
    </div>
  </div>
</div>
<!-- Modal Lista De Espera -->

<!-- Modal Bloqueo Académico -->
<div class="modal fade" id="modalBloqueoAcademico" tabindex="-1" aria-labelledby="modalBloqueoAcademico"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body">
        <p class="text-left">Estimado(a) Postulante:</p>
        <p class="text-left">
          De acuerdo a nuestros registros tienes una situación académica que regularizar, te solicitamos tomar
          contacto con la sede donde estudiaste anteriormente y regularizar tu situación antes de
          matricularte. Revisa contactos en <a
            href="https://www.tupuedes.cl/sistemas-de-admision/matricula-online/contacto-en-sede/">www.tupuedes.cl/sistemas-de-admision/matricula-online/contacto-en-sede/</a>
        </p>
        <p class="text-left">
          Atentamente, <br /> Dirección de Admisión, Santo Tomás.
        </p>
      </div>
    </div>
  </div>
</div>
<!-- Modal Bloqueo Académico -->
